import { Store } from 'vuex/types/index.js'
import { ArticleType, LocalStorage, State } from '@/types'

export function clearLocalStorageExpiration() {
  return new Date(0).toString()
}

export function createLocalStorageExpiration() {
  const localStorageExpDate = new Date()
  localStorageExpDate.setDate(localStorageExpDate.getDate() + 30)
  return localStorageExpDate.toString()
}

export function checkLocalStorageExpiration(store: Store<State>, localStorageData: LocalStorage) {
  const currentDateTimestamp = new Date()
  const localDataExpDate = new Date(localStorageData.expiry)

  if (localDataExpDate < currentDateTimestamp) {
    store.commit('clearSubmission')
    return true
  }

  return false
}

export function checkLocalStorageData(localStorageData: LocalStorage) {
  if (localStorageData !== null) {
    return true
  }
  else {
    return false
  }
}

export function checkLocalSubmissionValidity(store: Store<State>, localStorageData: LocalStorage, articleType: ArticleType) {
  const localDataSubmission: State = localStorageData.data

  const uploadFilesVerifyResultValid = !!(
    localDataSubmission.errors
    && localDataSubmission.errors.uploadFilesVerifyResult
    && localDataSubmission.errors.uploadFilesVerifyResult.valid
  )

  if (uploadFilesVerifyResultValid && localDataSubmission.activeSubmission.articleType == articleType) {
    return true
  }

  store.commit('clearSubmission')
  return false
}
